import Loader from 'components/Loader/Loader.component';
import { LoaderProps } from 'components/Loader/Loader.types';
import { useFormikContext } from 'formik';

export type FormLoaderProps = Omit<LoaderProps, 'active'>;

export default function FormLoader(props: FormLoaderProps) {
  // In order to work properly has to be have a <Formik> anchestor.
  const { isSubmitting } = useFormikContext();

  return <Loader {...props} active={isSubmitting} />;
}
